import { useRef } from 'react'
import { useEventListener } from './useEventListener.js'

export const useClickOutside = <T extends HTMLElement = HTMLDivElement>(
  handleClick: () => void,
  disable: {
    disableWhen?: boolean
    disableForElement?: HTMLElement | null
  },
) => {
  const ref = useRef<T>(null)

  const handleClickOutside = (event: MouseEvent) => {
    // We check if the ref is valid here instead of disabling
    // the click handler when the ref is null below
    if (!ref.current || disable.disableWhen) return
    if (
      clickedOutsideElement(ref.current)(event) &&
      (!disable.disableForElement ||
        clickedOutsideElement(disable.disableForElement)(event))
    )
      return handleClick()
  }

  // do not pass the ref to the last param disable when prop
  // refs are not reactive and the event listener will fail to reregister
  // when a null ref becomes defined
  useEventListener('click', handleClickOutside, document, disable.disableWhen)

  return ref
}

const clickedOutsideElement =
  (element: HTMLElement | null) => (event: MouseEvent) =>
    !element?.contains(event.target as Node)
